
export const boardQSPImap = {
    'ATMx201':
    {
        pinLocation:[[17],[19],[20],[22],[23],[24]],
        inUse:[1,1,1,1,0,0]
    },
    'ATMx251':
    {
        pinLocation:[[17],[19],[20],[22],[23],[24]],
        inUse:[1,1,1,1,0,0]
    },
    'ATMx202':
    {
        pinLocation:[[17],[5],[4],[6],[7],[19]],
        /* stacked flash */
        inUse:[1,1,1,1,1,1]
    },
    'ATMx221':
    {
        pinLocation:[[14],[15],[16],[17],[18],[19]],
        inUse:[1,1,1,1,0,0]
    },
    'ATMx231':
    {
        pinLocation:[[14],[15],[16],[17],[18],[19]],
        inUse:[1,1,1,1,0,0]
    },
    'ATM3325-xLxxQK':
    {
        pinLocation:[[6], [13], [2], [15], [16], [23]],
        /* stacked flash */
        inUse:[1,1,1,1,1,1]
    },
    'ATM3405-xPxxQK':
    {
        pinLocation:[[18],[19],[20],[21],[22],[17]],
        inUse:[1,1,1,1,0,0]
    },
    'ATM3425-xPxxQK':
    {
        pinLocation:[[18],[19],[20],[21],[22],[17]],
        inUse:[1,1,1,1,0,0]
    },
    'ATM3430e-xWxxQN':
    {
        pinLocation:[[32], [36], [31], [35], [34], [33]],
        /* stacked flash */
        inUse:[1,1,1,1,1,1]
    },
};

export const XX_X1X_PERIPHERALS = [
    {
        name: "gpio",
        pinNames: [
            "gpio"
        ],
        pinLocation: [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33
            ]
        ],
        "selection_type": "multi",
        numPins: 1,
        required: [
            0
        ]
    },
    {
        name: "ksi",
        pinNames: [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        pinLocation: [
            [
                23
            ],
            [
                22
            ],
            [
                21
            ],
            [
                20
            ],
            [
                19
            ],
            [
                18
            ],
            [
                13
            ],
            [
                12
            ],
            [
                11
            ],
            [
                10
            ],
            [
                9
            ],
            [
                8
            ],
            [
                7
            ],
            [
                6
            ],
            [
                5
            ],
            [
                4
            ],
            [
                3
            ],
            [
                2,
                32
            ],
            [
                1
            ],
            [
                0
            ]
        ],
        numPins: 20,
        required: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "qd",
        pinNames: [
            "qdx[0]",
            "qdx[1]",
            "qdy[0]",
            "qdy[1]",
            "qdz[0]",
            "qdz[1]"
        ],
        pinLocation: [
            [
                27,
                33
            ],
            [
                26,
                32
            ],
            [
                3,
                25
            ],
            [
                2,
                24
            ],
            [
                1,
                13
            ],
            [
                0,
                12
            ]
        ],
        numPins: 6,
        required: [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "kso",
        pinNames: [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        pinLocation: [
            [
                31
            ],
            [
                30
            ],
            [
                29
            ],
            [
                28
            ],
            [
                27
            ],
            [
                26
            ],
            [
                25
            ],
            [
                24
            ],
            [
                0,
                2,
                11
            ],
            [
                1,
                3,
                10
            ],
            [
                2,
                4,
                9
            ],
            [
                3,
                5,
                8
            ],
            [
                4,
                6,
                7
            ],
            [
                5,
                6,
                7
            ],
            [
                5,
                6,
                8
            ],
            [
                4,
                7,
                9
            ],
            [
                3,
                8,
                10
            ],
            [
                2,
                9,
                11,
                32
            ],
            [
                1,
                10,
                12
            ],
            [
                0,
                11,
                13
            ]
        ],
        numPins: 20,
        required: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "shub1",
        pinNames: [
            "miso",
            "mosi",
            "clk",
            "cs",
            "sda",
            "sck"
        ],
        pinLocation: [
            [
                9,
                27,
                33
            ],
            [
                2,
                8,
                26
            ],
            [
                0,
                6,
                24
            ],
            [
                1,
                7,
                25
            ],
            [
                13,
                32
            ],
            [
                11,
                12,
                31
            ]
        ],
        numPins: 6,
        required: [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "xpaon",
        pinNames: [
            "tx",
            "rx"
        ],
        pinLocation: [
            [
                0,
                10,
                11,
                25
            ],
            [
                20,
                21,
                23,
                24,
                25,
                27
            ]
        ],
        numPins: 2,
        required: [
            0,
            0
        ]
    },
    {
        name: "spi1",
        pinNames: [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        pinLocation: [
            [
                9,
                27,
                33
            ],
            [
                2,
                8,
                26
            ],
            [
                1,
                7,
                25
            ],
            [
                0,
                6,
                24
            ]
        ],
        numPins: 4,
        required: [
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "uart1",
        pinNames: [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        pinLocation: [
            [
                4,
                31,
                32
            ],
            [
                5,
                30,
                33
            ],
            [
                3,
                29
            ],
            [
                6,
                32
            ]
        ],
        numPins: 4,
        required: [
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "i2c0",
        pinNames: [
            "sda",
            "scl"
        ],
        pinLocation: [
            [
                4,
                10,
                30
            ],
            [
                3,
                9,
                29
            ]
        ],
        numPins: 2,
        required: [
            0,
            0
        ]
    },
    {
        name: "shub0",
        pinNames: [
            "miso",
            "mosi",
            "clk",
            "cs",
            "sda",
            "sck"
        ],
        pinLocation: [
            [
                13,
                23
            ],
            [
                11,
                12,
                22
            ],
            [
                9,
                10,
                20
            ],
            [
                10,
                11,
                21
            ],
            [
                4,
                10,
                30
            ],
            [
                3,
                9,
                29
            ]
        ],
        numPins: 6,
        required: [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "qspi",
        pinNames: [
            "clk",
            "cs",
            "d[0]",
            "d[1]",
            "d[2]",
            "d[3]"
        ],
        pinLocation: [
            [
                14,
                17,
                19
            ],
            [
                5,
                15,
                19
            ],
            [
                4,
                16,
                17,
                20
            ],
            [
                6,
                17,
                22
            ],
            [
                7,
                18,
                23
            ],
            [
                14,
                19,
                24
            ]
        ],
        numPins: 6,
        required: [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "pwm",
        pinNames: [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
        ],
        pinLocation: [
            [
                5,
                7
            ],
            [
                8,
                10
            ],
            [
                9,
                11
            ],
            [
                20,
                24
            ],
            [
                21,
                25
            ],
            [
                22,
                26
            ],
            [
                23,
                27
            ],
            [
                28
            ]
        ],
        numPins: 8,
        required: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "spi0",
        pinNames: [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        pinLocation: [
            [
                13,
                23
            ],
            [
                11,
                12,
                22
            ],
            [
                10,
                11,
                21
            ],
            [
                9,
                10,
                20
            ]
        ],
        numPins: 4,
        required: [
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "pdm",
        pinNames: [
            "clk",
            "in"
        ],
        pinLocation: [
            [
                9,
                24
            ],
            [
                10,
                25
            ]
        ],
        numPins: 2,
        required: [
            0,
            0
        ]
    },
    {
        name: "uart0",
        pinNames: [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        pinLocation: [
            [
                10,
                22,
                25
            ],
            [
                11,
                23,
                30
            ],
            [
                13,
                24
            ],
            [
                11,
                12,
                21
            ]
        ],
        numPins: 4,
        required: [
            0,
            0,
            0,
            0
        ]
    },
    {
        name: "i2c1",
        pinNames: [
            "sda",
            "scl"
        ],
        pinLocation: [
            [
                13,
                32
            ],
            [
                11,
                12,
                31
            ]
        ],
        numPins: 2,
        required: [
            0,
            0
        ]
    },
    {
        name: "gadc",
        pinNames: [
            "0 Diff",
            "0+ single",
            "0- single",
            "1- single"
        ],
        pinLocation: [
            [
                10,
                11
            ],
            [
                10
            ],
            [
                11
            ],
            [
                9
            ]
        ],
        numPins: 4,
        required: [
            0
        ]
    }
]
export const X3XX_5_PERIPHERALS = [
    {
        "name": "gpio",
        "pinNames": [
            "gpio"
        ],
        "pinLocation": [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30
            ]
        ],
        "selection_type": "multi",
        "numPins": 1,
        "required": [
            0
        ]
    },
    {
        "name": "qspi",
        "pinNames": [
            "clk",
            "csn",
            "(mosi) d[0]",
            "(miso) d[1]",
            "d[2]",
            "d[3]"
        ],
        "pinLocation": [
            [
                0,
                6,
                12,
                18,
                30
            ],
            [
                1,
                7,
                13,
                19,
                25
            ],
            [
                2,
                8,
                14,
                20,
                26
            ],
            [
                3,
                15,
                21,
                27
            ],
            [
                4,
                16,
                22,
                28
            ],
            [
                5,
                17,
                23,
                29
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "spi0",
        "pinNames": [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        "pinLocation": [
            [
                3,
                19,
                29
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                0,
                8,
                16,
                20,
                30
            ],
            [
                1,
                17,
                25,
                27
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "spi1",
        "pinNames": [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        "pinLocation": [
            [
                7,
                15,
                23
            ],
            [
                6,
                14,
                22
            ],
            [
                4,
                12,
                20
            ],
            [
                5,
                13,
                21
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "i2c0",
        "pinNames": [
            "sda",
            "scl"
        ],
        "pinLocation": [
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27,
                29
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                26,
                30
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "i2c1",
        "pinNames": [
            "sda",
            "scl"
        ],
        "pinLocation": [
            [
                3,
                7,
                15,
                19,
                23,
                29
            ],
            [
                2,
                6,
                14,
                18,
                22,
                26,
                28
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "pdm0",
        "pinNames": [
            "clk",
            "in"
        ],
        "pinLocation": [
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "pdm1",
        "pinNames": [
            "clk",
            "in"
        ],
        "pinLocation": [
            [
                2,
                6,
                14,
                18,
                22,
                26,
                28
            ],
            [
                3,
                7,
                15,
                19,
                23,
                29
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "i2s0",
        "pinNames": [
            "sd_in",
            "ws_in",
            "sck_in",
            "sd_out",
            "ws_out",
            "sck_out"
        ],
        "pinLocation": [
            [
                2,
                5,
                8,
                14,
                17,
                20,
                23,
                26,
                29
            ],
            [
                1,
                4,
                7,
                13,
                16,
                19,
                22,
                25,
                28
            ],
            [
                0,
                3,
                6,
                12,
                15,
                18,
                21,
                27,
                30
            ],
            [
                2,
                5,
                8,
                14,
                17,
                20,
                23,
                26,
                29
            ],
            [
                1,
                4,
                7,
                13,
                16,
                19,
                22,
                25,
                28
            ],
            [
                0,
                3,
                6,
                12,
                15,
                18,
                21,
                27,
                30
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "uart0",
        "pinNames": [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        "pinLocation": [
            [
                0,
                2,
                4,
                6,
                8,
                12,
                14,
                16,
                18,
                20,
                22,
                26,
                28,
                30
            ],
            [
                1,
                3,
                5,
                7,
                13,
                15,
                17,
                19,
                21,
                23,
                25,
                27,
                29
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                29,
                30
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "uart1",
        "pinNames": [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        "pinLocation": [
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ],
            [
                2,
                6,
                14,
                18,
                22,
                26,
                27,
                28
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ],
            [
                3,
                7,
                15,
                19,
                23,
                29
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "pwm",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
        ],
        "pinLocation": [
            [
                0,
                5,
                8,
                12,
                16,
                30
            ],
            [
                1,
                17,
                25,
                27
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                3,
                19,
                29
            ],
            [
                4,
                12,
                20
            ],
            [
                5,
                13,
                21
            ],
            [
                6,
                14,
                22
            ],
            [
                7,
                15,
                23
            ]
        ],
        "numPins": 8,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "ksi",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        "pinLocation": [
            [
                0,
                13,
                26
            ],
            [
                1,
                14
            ],
            [
                2,
                15
            ],
            [
                3,
                16
            ],
            [
                4,
                17
            ],
            [
                5,
                18
            ],
            [
                6,
                19
            ],
            [
                7,
                20
            ],
            [
                8,
                21
            ],
            [
                9,
                22,
                27
            ],
            [
                10,
                23,
                28
            ],
            [
                11,
                29,
                30
            ],
            [
                12,
                25
            ],
            [
                15
            ],
            [
                16
            ],
            [
                17
            ],
            [
                18
            ],
            [
                19
            ],
            [
                27
            ],
            [
                26
            ]
        ],
        "numPins": 20,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "kso",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        "pinLocation": [
            [
                0,
                13,
                26
            ],
            [
                1,
                14
            ],
            [
                2,
                15
            ],
            [
                3,
                16
            ],
            [
                4,
                17
            ],
            [
                5,
                18
            ],
            [
                6,
                19
            ],
            [
                7,
                20
            ],
            [
                8,
                21
            ],
            [
                9,
                22,
                27
            ],
            [
                10,
                23,
                28
            ],
            [
                11,
                29,
                30
            ],
            [
                12,
                25
            ],
            [
                23
            ],
            [
                24
            ],
            [
                28
            ],
            [
                29
            ],
            [
                30
            ],
            [
                27
            ],
            [
                26
            ]
        ],
        "numPins": 20,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "shub0",
        "pinNames": [
            "miso",
            "mosi",
            "sclk",
            "csn",
            "sda",
            "sck"
        ],
        "pinLocation": [
            [
                3,
                19,
                29
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                1,
                17,
                25,
                27
            ],
            [
                0,
                8,
                16,
                20,
                30
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27,
                29
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "shub1",
        "pinNames": [
            "miso",
            "mosi",
            "sclk",
            "csn",
            "sda",
            "sck"
        ],
        "pinLocation": [
            [
                7,
                15,
                23
            ],
            [
                6,
                14,
                22
            ],
            [
                5,
                13,
                21
            ],
            [
                4,
                12,
                20
            ],
            [
                3,
                19
            ],
            [
                2,
                18
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "qd",
        "pinNames": [
            "qdx[0]",
            "qdx[1]",
            "qdy[0]",
            "qdy[1]",
            "qdz[0]",
            "qdz[1]"
        ],
        "pinLocation": [
            [
                0,
                6,
                12,
                18,
                30
            ],
            [
                1,
                7,
                13,
                19,
                25
            ],
            [
                2,
                8,
                14,
                20,
                26
            ],
            [
                3,
                15,
                21,
                27
            ],
            [
                4,
                16,
                22,
                28
            ],
            [
                5,
                17,
                23,
                29
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "xlna",
        "pinNames": [
            "xpa0",
            "xpa1",
            "xpa2",
            "xpa3",
            "xpa4"
        ],
        "pinLocation": [
            [
                0,
                5,
                15,
                20,
                25,
                28
            ],
            [
                1,
                6,
                16,
                21,
                26,
                29
            ],
            [
                2,
                7,
                12,
                17,
                22
            ],
            [
                3,
                8,
                13,
                18,
                23
            ],
            [
                4,
                14,
                19,
                27,
                30
            ]
        ],
        "numPins": 5,
        "required": [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "gadc",
        "pinNames": [
            "0 Diff",
            "0+ single",
            "0- single",
            "1 Diff",
            "1+ single",
            "1- single"
        ],
        "pinLocation": [
            [
                6,
                7
            ],
            [
                6
            ],
            [
                7
            ],
            [
                4,
                5
            ],
            [
                4
            ],
            [
                5
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    }
]
export const X4XX_2_PERIPHERALS = [
    {
        "name": "gpio",
        "pinNames": [
            "gpio"
        ],
        "pinLocation": [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30
            ]
        ],
        "selection_type": "multi",
        "numPins": 1,
        "required": [
            0
        ]
    },
    {
        "name": "qspi",
        "pinNames": [
            "clk",
            "csn",
            "(mosi) d[0]",
            "(miso) d[1]",
            "d[2]",
            "d[3]"
        ],
        "pinLocation": [
            [
                0,
                6,
                12,
                18,
                30
            ],
            [
                1,
                7,
                13,
                19,
                25
            ],
            [
                2,
                8,
                14,
                20,
                26
            ],
            [
                3,
                15,
                21,
                27
            ],
            [
                4,
                16,
                22,
                28
            ],
            [
                5,
                17,
                23,
                29
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "spi0",
        "pinNames": [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        "pinLocation": [
            [
                3,
                19,
                29
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                0,
                8,
                16,
                20,
                30
            ],
            [
                1,
                17,
                25,
                27
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "spi1",
        "pinNames": [
            "miso",
            "mosi",
            "cs",
            "clk"
        ],
        "pinLocation": [
            [
                7,
                15,
                23
            ],
            [
                6,
                14,
                22
            ],
            [
                4,
                12,
                20
            ],
            [
                5,
                13,
                21
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "i2c0",
        "pinNames": [
            "sda",
            "scl"
        ],
        "pinLocation": [
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27,
                29
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                26,
                30
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "i2c1",
        "pinNames": [
            "sda",
            "scl"
        ],
        "pinLocation": [
            [
                3,
                7,
                15,
                19,
                23,
                29
            ],
            [
                2,
                6,
                14,
                18,
                22,
                26,
                28
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "pdm0",
        "pinNames": [
            "clk",
            "in"
        ],
        "pinLocation": [
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ]
        ],
        "numPins": 2,
        "required": [
            0,
            0
        ]
    },
    {
        "name": "i2s0",
        "pinNames": [
            "sd_in",
            "ws_in",
            "sck_in",
            "sd_out",
            "ws_out",
            "sck_out"
        ],
        "pinLocation": [
            [
                2,
                5,
                8,
                14,
                17,
                20,
                23,
                26,
                29
            ],
            [
                1,
                4,
                7,
                13,
                16,
                19,
                22,
                25,
                28
            ],
            [
                0,
                3,
                6,
                12,
                15,
                18,
                21,
                27,
                30
            ],
            [
                2,
                5,
                8,
                14,
                17,
                20,
                23,
                26,
                29
            ],
            [
                1,
                4,
                7,
                13,
                16,
                19,
                22,
                25,
                28
            ],
            [
                0,
                3,
                6,
                12,
                15,
                18,
                21,
                27,
                30
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "uart0",
        "pinNames": [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        "pinLocation": [
            [
                0,
                2,
                4,
                6,
                8,
                12,
                14,
                16,
                18,
                20,
                22,
                26,
                28,
                30
            ],
            [
                1,
                3,
                5,
                7,
                13,
                15,
                17,
                19,
                21,
                23,
                25,
                27,
                29
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                29,
                30
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "uart1",
        "pinNames": [
            "rx",
            "tx",
            "rts",
            "cts"
        ],
        "pinLocation": [
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27
            ],
            [
                2,
                6,
                14,
                18,
                22,
                26,
                27,
                28
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ],
            [
                3,
                7,
                15,
                19,
                23,
                29
            ]
        ],
        "numPins": 4,
        "required": [
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "pwm",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
        ],
        "pinLocation": [
            [
                0,
                5,
                8,
                12,
                16,
                30
            ],
            [
                1,
                17,
                25,
                27
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                3,
                19,
                29
            ],
            [
                4,
                12,
                20
            ],
            [
                5,
                13,
                21
            ],
            [
                6,
                14,
                22
            ],
            [
                7,
                15,
                23
            ]
        ],
        "numPins": 8,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "ksi",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        "pinLocation": [
            [
                0,
                13,
                26
            ],
            [
                1,
                14
            ],
            [
                2,
                15
            ],
            [
                3,
                16
            ],
            [
                4,
                17
            ],
            [
                5,
                18
            ],
            [
                6,
                19
            ],
            [
                7,
                20
            ],
            [
                8,
                21
            ],
            [
                9,
                22,
                27
            ],
            [
                10,
                23,
                28
            ],
            [
                11,
                29,
                30
            ],
            [
                12,
                25
            ],
            [
                15
            ],
            [
                16
            ],
            [
                17
            ],
            [
                18
            ],
            [
                19
            ],
            [
                27
            ],
            [
                26
            ]
        ],
        "numPins": 20,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "kso",
        "pinNames": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19"
        ],
        "pinLocation": [
            [
                0,
                13,
                26
            ],
            [
                1,
                14
            ],
            [
                2,
                15
            ],
            [
                3,
                16
            ],
            [
                4,
                17
            ],
            [
                5,
                18
            ],
            [
                6,
                19
            ],
            [
                7,
                20
            ],
            [
                8,
                21
            ],
            [
                9,
                22,
                27
            ],
            [
                10,
                23,
                28
            ],
            [
                11,
                29,
                30
            ],
            [
                12,
                25
            ],
            [
                23
            ],
            [
                24
            ],
            [
                28
            ],
            [
                29
            ],
            [
                30
            ],
            [
                27
            ],
            [
                26
            ]
        ],
        "numPins": 20,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "shub0",
        "pinNames": [
            "miso",
            "mosi",
            "sclk",
            "csn",
            "sda",
            "sck"
        ],
        "pinLocation": [
            [
                3,
                19,
                29
            ],
            [
                2,
                18,
                26,
                28
            ],
            [
                1,
                17,
                25,
                27
            ],
            [
                0,
                8,
                16,
                20,
                30
            ],
            [
                1,
                5,
                13,
                17,
                21,
                25,
                27,
                29
            ],
            [
                0,
                4,
                8,
                12,
                16,
                20,
                30
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "shub1",
        "pinNames": [
            "miso",
            "mosi",
            "sclk",
            "csn",
            "sda",
            "sck"
        ],
        "pinLocation": [
            [
                7,
                15,
                23
            ],
            [
                6,
                14,
                22
            ],
            [
                5,
                13,
                21
            ],
            [
                4,
                12,
                20
            ],
            [
                3,
                7,
                15,
                19,
                23,
                29
            ],
            [
                2,
                6,
                14,
                18,
                22,
                26,
                28
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "qd",
        "pinNames": [
            "qdx[0]",
            "qdx[1]",
            "qdy[0]",
            "qdy[1]",
            "qdz[0]",
            "qdz[1]"
        ],
        "pinLocation": [
            [
                0,
                6,
                12,
                18,
                30
            ],
            [
                1,
                7,
                13,
                19,
                25
            ],
            [
                2,
                8,
                14,
                20,
                26
            ],
            [
                3,
                15,
                21,
                27
            ],
            [
                4,
                16,
                22,
                28
            ],
            [
                5,
                17,
                23,
                29
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "xlna",
        "pinNames": [
            "xpa0",
            "xpa1",
            "xpa2",
            "xpa3",
            "xpa4"
        ],
        "pinLocation": [
            [
                0,
                5,
                15,
                20,
                25,
                28
            ],
            [
                1,
                6,
                16,
                21,
                26,
                29
            ],
            [
                2,
                7,
                12,
                17,
                22
            ],
            [
                3,
                8,
                13,
                18,
                23
            ],
            [
                4,
                14,
                19,
                27,
                30
            ]
        ],
        "numPins": 5,
        "required": [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        "name": "gadc",
        "pinNames": [
            "0 Diff",
            "0+ single",
            "0- single",
            "1 Diff",
            "1+ single",
            "1- single"
        ],
        "pinLocation": [
            [
                6,
                7
            ],
            [
                6
            ],
            [
                7
            ],
            [
                4,
                5
            ],
            [
                4
            ],
            [
                5
            ]
        ],
        "numPins": 6,
        "required": [
            0,
            0,
            0,
            0,
            0,
            0
        ]
    }
]
export const boardPinMap = {
    "ATMx201": [
        0,
        1,
        2,
        9,
        10,
        11,
        13,
        17,
        19,
        20,
        22,
        23,
        24,
        25,
        30,
        32,
        33
    ],
    "ATMx251": [
        0,
        1,
        2,
        9,
        10,
        11,
        13,
        17,
        19,
        20,
        22,
        23,
        24,
        25,
        30,
        32,
        33
    ],
    "ATMx202": [
        0,
        1,
        2,
        9,
        10,
        11,
        13,
        17,
        19,
        20,
        22,
        23,
        24,
        25,
        30,
        32,
        33
    ],
    "ATMx221": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33
    ],
    "ATMx231": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        28,
        29,
        30,
        31,
        32,
        33
    ],
    "ATM3325-xxxxCM": [
        0,
        1,
        3,
        4,
        5,
        6,
        7,
        12,
        13,
        14,
        15,
        17,
        18,
        19,
        20,
        21,
        22,
        25,
        27,
        29,
        30
    ],
    "ATM3325-xDxxQK": [
        0,
        1,
        3,
        4,
        5,
        6,
        7,
        12,
        13,
        14,
        15,
        17,
        18,
        19,
        20,
        21,
        22,
        25,
        27,
        29,
        30
    ],
    "ATM3325-xLxxQK": [
        0,
        1,
        3,
        4,
        5,
        7,
        8,
        14,
        17,
        18,
        19,
        20,
        21,
        22,
        25,
        27,
        29,
        30
    ],
    "ATM3330x-xxxxQN": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
    ],
    "ATM3405-xPxxQK": [
        0,
        1,
        3,
        4,
        5,
        6,
        7,
        12,
        13,
        14,
        15,
        17,
        18,
        19,
        20,
        21,
        22,
        25,
        27,
        29,
        30
    ],
    "ATM3425-xPxxQK": [
        0,
        1,
        3,
        4,
        5,
        6,
        7,
        12,
        13,
        14,
        15,
        17,
        18,
        19,
        20,
        21,
        22,
        25,
        27,
        29,
        30
    ],
    "ATM3430e-xWxxQN": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
    ]
}
export const peripheral_map = {
	'XX-X1X': XX_X1X_PERIPHERALS,
	'X3XX-5': X3XX_5_PERIPHERALS,
	'X4XX-2': X4XX_2_PERIPHERALS,
};